/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/RectTool',['./Tool', '../shapes/RectShape'], function (Tool, RectShape) {
	'use strict';

	var RectTool = Tool.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			// eslint-disable-line no-unused-vars
			RectTool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {
			var rect = new RectShape({
				canvas: canvas,
				xCoord: xCoord,
				yCoord: yCoord,
				borderColor: this.borderColor,
				fillColor: this.fillColor
			});
			return rect;
		}

	});

	return RectTool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

